/** Image affichée en grand par-dessus la carte (voir `EntityPanel`), fermée par clic ou Échap. */
export class ImageLightbox {
  private element: HTMLDivElement | null = null;
  private handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") this.close();
  };

  constructor(private container: HTMLElement) {}

  open(src: string, alt: string): void {
    this.close();

    const overlay = document.createElement("div");
    overlay.className = "toka-image-lightbox";
    overlay.addEventListener("click", () => this.close());

    const image = document.createElement("img");
    image.className = "toka-image-lightbox__image";
    image.src = src;
    image.alt = alt;
    overlay.appendChild(image);

    const closeButton = document.createElement("button");
    closeButton.type = "button";
    closeButton.className = "toka-image-lightbox__close";
    closeButton.textContent = "×";
    closeButton.setAttribute("aria-label", "Fermer");
    overlay.appendChild(closeButton);

    document.addEventListener("keydown", this.handleKeyDown);
    this.container.appendChild(overlay);
    this.element = overlay;
  }

  close(): void {
    document.removeEventListener("keydown", this.handleKeyDown);
    this.element?.remove();
    this.element = null;
  }
}
